<template>
  <PgButtonActionsContext
    :actions="actions"
    class="page-query-top-search-iframe flex flex-v"
    style="height: 100%"
  >
    <PgButtonGroup
      v-if="!!topButtons?.length > 0"
      class="pg-page-query__button"
      :list="topButtons"
      :type="'text'"
      :round="false"
      :compileData="compileData"
    >
      <template #right>
        <slot name="topButton"></slot>
      </template>
    </PgButtonGroup>
    <PgCriteriaForm
      ref="PgCriteriaFormRef"
      v-if="!!queryForm?.items?.length > 0"
      @search="search"
      :formData="queryData"
      :formItems="queryForm"
      @clear="PgCriteriaFormClear"
      @getCriteriaParam="updateCriteriaQueryData"
      :showOtherOptions="true"
      :formSaveUrl="formSaveUrl"
      :collapse="collapse"
    >
      <template>
        <el-button
          type="primary"
          round
          class="pg-criteria-form_btn-search"
          style="height: 24px; margin-top: 6px; margin-left: 10px"
          @click="openNewWindow"
          >弹窗查询</el-button
        >
      </template>
    </PgCriteriaForm>
    <!-- 如果没有高级查询条件，就显示这个弹窗查询按钮 -->
    <el-button
      v-else
      type="primary"
      round
      class="pg-criteria-form_btn-search"
      style="height: 28px; margin-top: 8px"
      @click="openNewWindow"
      >弹窗查询</el-button
    >
    <div class="page-query-top-search-iframe-empty" v-if="!showIframe">
      <img src="../../../static/image/empty.png" />
      <span>请点击查询</span>
    </div>
    <iframe
      v-if="showIframe"
      style="flex-grow: 1"
      scrolling="yes"
      frameborder="0"
      :width="iframeWidth()"
      :frame_name="frame_name"
      seamless
      :src="iframeSrc"
    ></iframe>
  </PgButtonActionsContext>
</template>
<script setup>
// vue
import { ref, onMounted, onBeforeUnmount, computed } from 'vue'

// hook
import { useCriteriaQueryIframe } from '../hook/use-criteria-query-iframe'
import { useSetStorageComponent } from '../../criteria-form/hook/use-set-storage-component'
import { useRoute } from 'vue-router/composables'
import { useTopErrors, useBeforValueActionsProvide } from '../../../hooks/index'

// 组件
import { PgButtonActionsContext } from '../../button-actions-context/index'
import { PgButtonGroup } from '../../button-group/index'
import { PgCriteriaForm } from '../../criteria-form/index'
import { pgMessageBox } from '../../message-box/index'

// utils
import { http } from '../../../utils/index'
import { jmreport } from '../utils/jmreport'

const props = defineProps({
  // 高级查询条件
  url: {
    type: String,
    default: 'rest/ezcomp/dict/form/fetch/',
  },
  parametersStorageSuffix: String,
  formData: {
    type: Object,
    default: null,
  },
  beforActions: Object,
  //表单或表格字段数据变化后的回调
  afterCallback: Function,
  buttonActions: Object,
  collapse: Boolean,
})

// 报表管理 使用高级查询时，对于查询条件保存部分，接口特殊处理
const formSaveUrl = ref({
  save: '/rest/main/report/report/menu/submit',
  get: '/rest/main/report/report/menu/options',
  remove: '/rest/main/report/report/menu/remove',
  getSaveParam: '/rest/main/report/report/menu/ofEdit',
})

const PgCriteriaFormRef = ref(null)
// useRoute
const route = useRoute()

// 查找按钮
const iframeProperty = ref(null)
const beforeSearch = async () => {
  if (!iframeProperty.value) return true
  const [res] = await http[iframeProperty.value.method](
    iframeProperty.value.url,
    Object.assign({}, iframeProperty.value.param ?? {}, { parameters: queryData.value })
  )

  if (!res.data) {
    pgMessageBox({
      title: '提示',
      message: res.msg,
    })
    return false
  } else {
    return true
  }
}
const search = async (openWindow) => {
  const res = await beforeSearch()
  if (!res) return false
  setIframeSrc()
  calculateIframeScope()
  if (openWindow) window.open(iframeSrc.value, '_blank')
}

// 高级查询 保存的查询条件，获取到的参数处理
const updateCriteriaQueryData = (data) => {
  updateQueryData(data)
}

// 清空高级查询
const PgCriteriaFormClear = () => {
  updateQueryData({}, true)
}

const {
  setParametersBySessionStorage,
  setComponentBySessionStorage,
  getComponentBySessionStorage,
  removeComponentBySessionStorage,
  removeParametersBySessionStorage,
  getComponentByLocalStorage,
  setParametersByLocalStorage,
  setComponentByLocalStorage,
} = useSetStorageComponent(props.parametersStorageSuffix)

const handleComponentStorage = {
  get: () => {
    if (cacheType.value == 'local') {
      return getComponentByLocalStorage()
    } else {
      return getComponentBySessionStorage()
    }
  },
  set: () => {
    if (cacheType.value == 'local') {
      setParametersByLocalStorage(queryData.value)
      setComponentByLocalStorage({
        showIframe: showIframe.value,
      })
    } else {
      setParametersBySessionStorage(queryData.value)
      setComponentBySessionStorage({
        showIframe: showIframe.value,
      })
    }
  },
}

// iframe
const iframeWidth = () => {
  if (document.getElementById('layoutTemplate_single_page_con'))
    return document.getElementById('layoutTemplate_single_page_con').clientWidth
  else return '100%'
}

const frame_name = computed(() => {
  return route.query.id
})

const showIframe = ref(false)

const calculateIframeScope = () => {
  iframeWidth()
  showIframe.value = false
  setTimeout(() => {
    showIframe.value = true
    handleComponentStorage.set()
  }, 500)
}

const iframeView = ref('')
const iframeSrc = ref('')
const setIframeSrc = () => {
  let url = iframeView.value
  if (queryForm?.value?.items?.length <= 0) iframeSrc.value = url
  else {
    queryForm?.value?.items
    url += `?organizationId=${route.query.organizationId}`
    Object.keys(queryData.value).forEach((im) => {
      if (queryData.value[im] !== null)
        url += `&${getIframeParamFromQueryForm(im)}=${queryData.value[im]}`
    })
    iframeSrc.value = url
  }
}

const getIframeParamFromQueryForm = (code) => {
  let tempObj = queryForm?.value?.items.find((im) => im.property == code)
  if (tempObj) return tempObj.param ? tempObj.param : tempObj.code
  else return code
}

const openNewWindow = () => {
  if (PgCriteriaFormRef.value)
    PgCriteriaFormRef.value.search(() => {
      search(true)
    })
  else search(true)
}

// 设置
const {
  setQueryForm,
  setDefaultQuery,
  queryForm,
  queryData,
  updateQueryData,
  getCriteria,
  cacheType,
} = useCriteriaQueryIframe(props.url, props.parametersStorageSuffix)

const compileData = ref({
  queryForm,
  queryData,
})

// 获取顶部按钮配置
const topButtons = ref([])

const { updateErrors, updateSuccess } = useTopErrors()

const actions = {
  ...props.buttonActions,
  updateTopErrors: ({ errors }) => updateErrors(errors),
  updateTopSuccess: ({ data }) => updateSuccess(data),
  splitPrintByIframeCode: ({ data, param }) => {
    // 自定义方法，打印
    jmreport(data, param)
  },
}

const resize = () => {
  PgCriteriaFormRef.value.search(() => {
    calculateIframeScope()
  }, false)
}

// 修改字段值前的勾子
const beforActions = {
  ...props.beforActions,
}
useBeforValueActionsProvide({
  beforActions,
  formReactive: {},
  actions,
  afterCallback: props.afterCallback,
})

onMounted(() => {
  window.addEventListener('resize', resize, false)
  getCriteria().then(([res, defaultParameter]) => {
    setQueryForm(res)
    iframeView.value = res.view
    //  #7506 报表有静态参数，需求新增参数 property 是一个对象，目前包含属性property:{url:'',param:{}, method:'get',}
    if (res.property?.url) {
      iframeProperty.value = res.property
    }
    if (defaultParameter) {
      // 默认不展示查询-如果
      showIframe.value = handleComponentStorage.get()?.showIframe ?? false
      updateQueryData(Object.assign(defaultParameter, props.formData))
    } else {
      setDefaultQuery(props.formData)
    }

    setIframeSrc()

    if (queryForm.value?.items?.length <= 0) {
      showIframe.value = true
    }

    topButtons.value = res.buttons ? res.buttons : []
  })
})

onBeforeUnmount(() => {
  removeComponentBySessionStorage()
  removeParametersBySessionStorage()
  window.removeEventListener('resize', resize, false)
})
</script>
<style lang="sass" scoped>
.page-query-top-search-iframe {
  .pg-page-query__button {
      height: 40px;
      background-color: var(--layout-main-background-color);
      border-bottom: 1px solid var(--pg-page-edit-top-border-color);
      padding: 0 20px;

      .el-button {
          font-size: var(--font-size-2);
      }
  }
  .page-query-top-search-iframe-empty{
    flex: 1 auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    span{
      color: var(--color-info);
      font-size: var(--font-size-2);
      margin-top: 10px;
    }
  }
}
</style>
